import Table from 'cli-table2';

const basicTable = () =>
  new Table({
    head: [],
    chars: {
      top: '═',
      'top-mid': '╤',
      'top-left': '╔',
      'top-right': '╗',
      bottom: '═',
      'bottom-mid': '╧',
      'bottom-left': '╚',
      'bottom-right': '╝',
      left: '║',
      'left-mid': '╟',
      mid: '─',
      'mid-mid': '┼',
      right: '║',
      'right-mid': '╢',
      middle: '│',
    },
  });

module.exports = {
  basicTable,
};



// WEBPACK FOOTER //
// ./src/utils/table.js